import React from 'react';
import { observer } from 'mobx-react';
import { CalendlyPopupWidget } from '../../../../common/components/CalendlyPopupWidget/CalendlyPopupWidget';
import { DemoBannerButton, DemoBannerText, DemoBannerWrapper, MobileDemoBannerButton, MobileDemoBannerText, MobileDemoBannerWrapper } from './portfolios.styles';
import { useStore } from '../../../app/data/root.store';
import { ROUTES } from '../../../../common/constants/routes.const';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../../../app/data/AnalyticsProvider';
export const B2BDemoBanner = observer(({ handleBookACallClick }) => {
  const { uiStore: { isDesktopView }, userStore: { isViewingOwnPortfolio } } = useStore();
  const location = useLocation();
  const isViewingClientWealthPage = !isViewingOwnPortfolio && location.pathname.includes(ROUTES.wealth.url);
  
  return (
    isDesktopView ?
      <DesktopDemoBanner handleBookACallClick={handleBookACallClick} isViewingClientWealthPage={isViewingClientWealthPage} /> :
      <MobileDemoBanner handleBookACallClick={handleBookACallClick} />
  );
});

const DesktopDemoBanner = ({ handleBookACallClick, isViewingClientWealthPage }) => {
  const { mixpanelTrack } = useAnalytics();
  const handleBookACallMixpanel = () => {
    mixpanelTrack('CTA Clicked', {
      cta_text: 'Schedule a call',
      destination: 'Schedule B2B Call Popup',
      location: 'B2B Master Account',
      type: 'button',
      url: window.location.href,
    });
  };
  return (
    <DemoBannerWrapper isViewingClientWealthPage={isViewingClientWealthPage}>
      <DemoBannerText>{!isViewingClientWealthPage ? `This is just the demo. Let's build your real dashboard` : `Ready to start adding your managed portfolio?`}</DemoBannerText>
      <CalendlyPopupWidget
        onScheduleSuccess={handleBookACallClick}
        triggerComponent={(
          <DemoBannerButton onClick={handleBookACallMixpanel}>
            Schedule a call
          </DemoBannerButton>
        )}
        triggerWrapperStyles={{ marginBottom: '0px' }}
      />
    </DemoBannerWrapper>
  );
}

const MobileDemoBanner = ({ handleBookACallClick }) => {
  return (
    <MobileDemoBannerWrapper>
      <MobileDemoBannerText>You are in Demo mode</MobileDemoBannerText>
      <CalendlyPopupWidget
        onScheduleSuccess={handleBookACallClick}
        triggerComponent={(
          <MobileDemoBannerButton>
            Schedule a call
            <UserArrowLinkSvg />
          </MobileDemoBannerButton>
        )}
        triggerWrapperStyles={{ marginBottom: '0px' }}
      />
    </MobileDemoBannerWrapper>
  );
}

const UserArrowLinkSvg = () => {
  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.1708 8.1875C10.1708 8.1875 14.0097 8.1875 15.7487 8.1875C15.7487 9.92646 15.7487 13.7654 15.7487 13.7654" stroke="#1A1B1D" strokeWidth="1.60304" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.625 15.3154L15.5063 8.43417" stroke="#1A1B1D" strokeWidth="1.60304" strokeLinecap="round" />
    </svg>
  )
}